/**
 * wayai send-message — send a test message to a hub (preview or production) and get the agent reply
 *
 * Chat hubs: automatically continues the active conversation (or creates one).
 * Task hubs: creates a new conversation by default. Use -c to continue an existing one.
 *
 * Usage:
 *   wayai send-message "Hello, I need help"                       # send message
 *   wayai send-message -c <conversation_id> "Follow up"           # continue conversation
 */

import { requireAuth } from '../lib/auth.js';
import { requireRepoConfig } from '../lib/repo-config.js';
import { resolveActiveHubId } from '../lib/workspace.js';
import { ApiClient } from '../lib/api-client.js';

export async function sendMessageCommand(args: string[]): Promise<void> {
  const hubId = resolveActiveHubId(args);
  const { config, accessToken } = await requireAuth();
  requireRepoConfig();

  // Parse args
  let conversationId: string | undefined;
  let message: string | undefined;

  for (let i = 0; i < args.length; i++) {
    const arg = args[i];
    if (arg === '-c' || arg === '--conversation') {
      conversationId = args[++i];
    } else if (!arg.startsWith('-')) {
      message = arg;
    }
  }

  if (!message) {
    console.error('Usage: wayai send-message [options] "message text"');
    console.error('');
    console.error('Options:');
    console.error('  -c, --conversation <id>  Continue an existing conversation');
    console.error('');
    console.error('The hub type (chat/task) is determined automatically from the hub.');
    console.error('Chat hubs auto-continue the active conversation (or create one).');
    console.error('Task hubs create a new conversation unless -c is provided.');
    process.exit(1);
  }

  const client = new ApiClient({ apiUrl: config.api_url, accessToken });

  const result = await client.sendMessage(hubId, message, {
    conversationId,
  });

  // Print result
  console.log(`Conversation: ${result.conversation_id}`);
  console.log(`Status: ${result.status}`);

  if (result.status_reason) {
    console.log(`Reason: ${result.status_reason}`);
  }

  if (result.agent_reply) {
    console.log('');
    console.log(result.agent_reply.message_text);
  } else if (result.status === 'skipped') {
    console.log('(Agent did not respond)');
  } else if (result.status === 'error') {
    console.log('(Agent processing failed — user message was stored)');
  }
}
